// extracted by mini-css-extract-plugin
module.exports = {"basePre":"BasePre_basePre_2jFPj"};